import { forwardRef } from 'react';
import { Hint } from '../hint/hint.component';
import type { HintUIProps } from '../hint/hint.component';
import { HoverLabelStyles } from './hover-label.styles';
import { ThemeProps } from './types';

type Props = HintUIProps & Partial<ThemeProps>;

export const HoverLabel = forwardRef<HTMLParagraphElement, Props>(({ theme = 'dark', ...rest }, ref) => {
  const styles = HoverLabelStyles.hoverLabel({ theme });

  return <Hint css={styles} {...rest} ref={ref} />;
});
